module.exports = __webpack_public_path__ + "static/trivia-172dbba743a28a25354f6b807dee15cc.png";